import * as firebase from 'firebase/app';
/* eslint-disable import/no-duplicates */
import 'firebase/auth';
import 'firebase/storage';
/* eslint-enable import/no-duplicates */
import config from 'config';

// export firebase app
const app = !firebase.apps.length
  ? firebase.initializeApp(config.firebase)
  : firebase.app();

const storage = firebase.storage(app);

const store = storage.ref();

export { app as default, firebase, store };
